import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment"
import { map, share } from "rxjs/operators";
import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';

@Injectable({ providedIn: 'root' })export class ReportGeneratorService {

  queryPath;
  dataArySubs = new Subject();
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor( private http: HttpClient) {
    // this.setQueryPath()
  }


  getData(body) {
    body = JSON.stringify(body);
    body = JSON.parse(body)
    delete body['focusBy']
    return this.http.post(environment.apiUrl + "/widgets/reportgenerator", JSON.stringify(body), this.httpOptions).pipe(map(res => {
      if (Array.isArray(res)) {
        return res.map((item) => { return { ...item, date: moment.unix(item.unix).tz('Europe/Oslo').format('DD-MM-YYYY HH:mm'), groupId: item.user.groupId ? item.user.groupId : "Unknow" , userName: item.user.name ? item.user.name : "Unknow"} });
      } else {
        return null;
      }
    })).pipe(share());;
  }

  getDataByProduct(body) {
    body = JSON.stringify(body);
    body = JSON.parse(body)
    delete body['focusBy']
    delete body['systemId']
    delete body['siteId']
    return this.http.post(environment.apiUrl + "/widgets/reportgeneratorbyprodcut", JSON.stringify(body), this.httpOptions).pipe(map(res => {
      if (Array.isArray(res)) {
        return res.map((item) => { return { ...item, date: moment.unix(item.unix).tz('Europe/Oslo').format('DD-MM-YYYY HH:mm') } });
      } else {
        return null;
      }
    })).pipe(share());;
  }

  getAll(body) {
 body = JSON.stringify(body);
    body = JSON.parse(body)
    body.status = true
    console.log(body)
    delete body['focusBy']
    // console.log(moment.tz.names())
    return this.http.post(environment.apiUrl + "/widgets/reportgenerateall", JSON.stringify(body), this.httpOptions).pipe(map(res => {
      if (Array.isArray(res)) {

        // return res.map((item) => { return { ...item,project:item.project != null ? item.project.name: 'Not Assigned', freeText:item.freeText != null  ? item.freeText: '-'}});

        return res.map((item) => { return { ...item, discount:item.discount?item.discount+"%" : 0, subsidized:  (item.price * (item.discount / 100)).toFixed(2) , groupId: item.user ? item.user.groupId : "Unknow" ,userName: item.user ? item.user.name : "Unknow", date: moment.unix(item.unix).tz('Europe/Oslo').format('DD-MM-YYYY HH:mm'), department: item.department != null ? item.department.alias : 'Not Assigned', project: item.project != null ? item.project.id : 'Not Assigned', freeText: item.freeText != null ? item.freeText : '-' } }).sort((a, b) => b.unix - a.unix)

      } else {
        return null
      }
    })).pipe(share());;
  }

}